import { render } from "./px-date-select.vue?vue&type=template&id=fa1f4992&scoped=true&ts=true"
import script from "./px-date-select.vue?vue&type=script&lang=ts"
export * from "./px-date-select.vue?vue&type=script&lang=ts"

import "./px-date-select.vue?vue&type=style&index=0&id=fa1f4992&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa1f4992"]])

export default __exports__